import ReviewsGrid from "../../components/ReviewsCarousel";
import "../../styles/ReviewsSection.css";

// Remplacer par l'URL Google Maps / Google Business de la fiche
const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?sxsrf=ANbL-n7WA-_VrZpJxVPyNC6KdQCJ01siaA:1779535384723&q=GUCANT+INFORMATIQUE+Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2Njc1MTMyMzMysTA2szA3sjQ32MDI-IpRwj3U2dEvRMHTz80_yNcxxDMw1FXBsSyzeBErTikA2pAxqFAAAAA&rldimm=3754626624836872970&tbm=lcl&hl=fr-FR&cshid=1779535479963879#lkt=LocalPoiReviews";

const ReviewsSection = ({ reviews = [], isLoading }) => {
  if (isLoading || reviews.length === 0) {
    return null;
  }

  return (
    <div id="reviews" className="reviews-section section">
      <h2 className="section-title">Avis Google</h2>
      <ReviewsGrid reviews={reviews} />
      <a
        href={GOOGLE_REVIEWS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="reviews-section__google-btn material-shadow"
      >
        Voir sur Google
      </a>
    </div>
  );
};

export default ReviewsSection;
